import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import '@morefunos/ui/tokens.css';
import '@morefunos/ui/base.css';
import '@morefunos/ui/mobile-ordering.css';
import './smm.css';
import {App} from './App.tsx';

const root = document.getElementById('root');
if (!root) throw new Error('SMM_ROOT_REQUIRED');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
